import React from 'react';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';
import { reportDescriptionExpandedEvent, Events } from '../../../../utils/reports/expandDescription';
import withImpressions from '../../hoc/withImpressions';
import { EXPAND_BUTTON_FILTER_CLASS, IMPRESSION_CONFIG } from './constants';

import './styles.scss';

export const ExpandButton = ({ textExpanded, onClick, className }) => {
    const handleClick = () => {
        if (!textExpanded) {
            reportDescriptionExpandedEvent(Events.seeMore);
        } else {
            reportDescriptionExpandedEvent(Events.seeLess);
        }

        onClick();
    };

    const moreText = textExpanded ? 'show_less' : 'show_more';

    return (
        <span className="expand-button">
            <Button
                className={classnames(EXPAND_BUTTON_FILTER_CLASS, 'expand-button-text', className)}
                onClick={handleClick}
            >
                <span className="text-normal">
                    <u>
                        <I18n k={`reviews.general.${moreText}`} />
                    </u>
                </span>
            </Button>
        </span>
    );
};

export default withImpressions(ExpandButton, IMPRESSION_CONFIG);
